import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=63e2d5c0&scoped=true&"
import script from "./Note.vue?vue&type=script&lang=ts&"
export * from "./Note.vue?vue&type=script&lang=ts&"
import style0 from "./Note.vue?vue&type=style&index=0&id=63e2d5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e2d5c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e2d5c0')) {
      api.createRecord('63e2d5c0', component.options)
    } else {
      api.reload('63e2d5c0', component.options)
    }
    module.hot.accept("./Note.vue?vue&type=template&id=63e2d5c0&scoped=true&", function () {
      api.rerender('63e2d5c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Timeline/Note.vue"
export default component.exports